export const BlockchainOwnerAddress = "0x0181d208d615036fFA271Fe61610b5482eA1618E"


// WEBPACK FOOTER //
// ./src/constants/BlockchainOwnerAddress.js